import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { P3, GradientSpan, P1 } from "../theme/text/Headings";
import { Blue, DarkGrey, Pink, White } from "../theme/colors";
import remoteQuizService from "../../services/RemoteQuizService";

const CompletionBox = styled.div`
  background: ${DarkGrey};
  border-radius: 15px;
  padding: 16px 25px;
  text-align: center;
`;

const QuizCompletionBox = ({ userProfile, style }) => {
  const [completedQuizzes, setCompletedQuizzes] = useState(0);
  const [missingQuizzes, setMissingQuizzes] = useState([]);

  useEffect(() => {
    const checkMissingQuizzes = async () => {
      // Get all quiz configs from remote
      const allQuizConfigs = await remoteQuizService.getAllQuizConfigs();
      if (!allQuizConfigs) return;

      const missing = [];
      let totalCoreQuizzes = 0;
      for (const [quizType, config] of Object.entries(allQuizConfigs)) {
        // Exclude non-core quizzes from completion requirements
        if (config && config.excludeFromProfileCompletion) continue;
        totalCoreQuizzes++;
        const quizId = userProfile?.[config.databaseField];
        if (!quizId) {
          missing.push({
            type: quizType,
            title: config.titleWord,
          });
        }
      }
      setMissingQuizzes(missing);
      setCompletedQuizzes(totalCoreQuizzes - missing.length);
    };

    if (userProfile) {
      checkMissingQuizzes();
    }
  }, [userProfile]);

  // Don't show the box if all quizzes are completed
  if (missingQuizzes.length === 0) {
    return null;
  }

  return (
    <div style={style}>
      <CompletionBox>
        <P1 color={White} style={{ margin: "0 0 5px 0", fontWeight: 800 }}>
          <GradientSpan $background={Blue} $transitionBackground={Pink}>
            {completedQuizzes}/5 Core Quizzes Completed
          </GradientSpan>
        </P1>
        <P3 color={White}>
          Complete your core quizzes to unlock insights and connect better with
          friends
        </P3>
      </CompletionBox>
    </div>
  );
};

export default QuizCompletionBox;
